import React, { useState } from "react";
import { uri } from "../../../../../help/Api";
import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost";
import { useEffect } from "react";
import { insh, sto } from "../../../../../Context/InshData";
import BackdropScI from "../../../../../services/BackdropScI";
import MultiVoucher from "./MultiVoucher";
import dataF from "../../../../../Server/dataF.json";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { accountsURL } from "../../../../../api/EReceipt";
import { Dialog } from "@material-ui/core";

export function getReFormatingAccount(data) {
  const newData = data.map((row, i) => {
    return {
      id: row.Code,
      name: row.AName,
      acc_omlat: row?.omlat?.map((om) => {
        return om.omla_id;
      }),
    };
  });
  return newData;
}

function MultiVoucherItem(props) {
  const [branch, setBranch] = useState({ id: -1, name: "الكل" });
  const tb = {
    wait: true,
    Branch: true,
    stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },
    parms: { 
        branch: branch.id == -1 ? sto.branchi : branch.id ,
        iempid: sto.empi,
     },

  };

  const { object: AutoOptionsB, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
    [branch]
  );
  const tttb = {
    wait: true,
    other: true,
    Stocks: true, // Error // out
    Banks: true,
    Users:true,
    costcenters: true,
    CheckStatus: true,
    omlat: true,
    PermissionsElemnts: true,
    /*params*/ // out
    parms: {
      ibranchid:  branch.id == -1 ? sto.branchi : branch.id ,
      iempid: sto.empi,
      iuserid: sto.idi,
      scurrenciestype: "I",
      branch:  branch.id == -1 ? sto.branchi : branch.id ,
      tname: props.isReceipt ? "sandmq" : "sandms",
      withOmlat: true,
      iformid: dataF[66].id,
    },
    autos: {
      Safes: true,
      Stocks: true,
      Banks: true,
      Users:true,
      costcenters: true,
      CheckStatus: true,
      omlat: true,
    },
  };

  useEffect(() => {
    console.log("hello ", data);
  });

  const url = uri + "Res";

  const {
    object: AutoOptions,
    fetching: fetchinData,
    fetch: fetchURL,
  } = useFetchObjectByPost(url, tttb, [branch]);
  const {
    data,
    fetching,
    fetchURL: fetchURL1,
  } = useFetchURL({
    ...{
      url: accountsURL,
      mapFunction: getReFormatingAccount,
    },
  });
  if (fetchinData || !AutoOptions?.Stocks ||!AutoOptionsB?.Branches || !data || fetching)
    return <BackdropScI />;
  return (
    <MultiVoucher
      {...{
        AutoOptions: AutoOptions?.Stocks
          ? { ...AutoOptions, Customers: data }
          : [],
        fetchURL,
        prmis: AutoOptions?.permisElm ?? insh.permiElm,
        ...props,
        AutoOptionsB: AutoOptionsB?.Branches? AutoOptionsB: [],
        branch,
        setBranch,
      }}
    />
  );
}

export default function MReceiptVoucherCon() {
  return (
    <MultiVoucherItem
      {...{
        isDialog: false,
        isReceipt: true,
        isDialogData: false,

      }}
    />
  );
}

export function MExchangVoucherCon() {
  return (
    <MultiVoucherItem
      {...{
        isDialog: false,
        isReceipt: false,
        isDialogData: false,
      }}
    />
  );
}

export function MultiVoucherLink(props) {
  const { data: item, onClose } = props;

  return (
    <MultiVoucherItem
      {...{
        isDialog: true,
        isReceipt: true,
        item,
        onClose,
        isDialogData: false,

      }}
    />
  );
}


export function MultiSarfDataDialog(props) {
  //const { data: item, onClose } = props;
  const {open, onClose,onSave ,invData } = props;

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
     <MultiVoucherItem
    {...{
      isDialog: false,
      isReceipt: false,
      invData,
      onClose,
      isDialogData: true,

    }}/>
    </Dialog> 

)


}


export function MultiQabdDataDialog(props) {
  //const { data: item, onClose } = props;
  const {open, onClose,onSave ,invData } = props;

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
     <MultiVoucherItem
    {...{
      isDialog: false,
      isReceipt: true,
      invData,
      onClose,
      isDialogData: true,

    }}/>
    </Dialog> 

)
}
